import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  background: var(--white-dark);
  display: flex;
  flex-direction: column;

  @media (max-width: 800px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px 30%;

  @media (max-width: 800px) {
    padding: 32px 24px;
  }
`;

export const UserContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;

  img {
    height: 80px;
    width: 80px;
    border-radius: 50%;
    margin-right: 25px;
    object-fit: cover;
  }

  > div {
    display: flex;
    align-items: center;
    color: var(--black-2);
  }

  > svg {
    color: var(--gray-c);
  }

  button.notifications {
    cursor: pointer;

    height: 56px;
    width: 56px;
    background: var(--white-darker);
    color: var(--gray-9);
    border-radius: 50%;
    transition: 0.2s ease;

    display: grid;
    place-items: center;

    :hover {
      background: var(--gray-d);
    }
  }
`;

export const SyncBar = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 30px;

  background: var(--white-darker);
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;

  span {
    margin-left: 20px;
    font-size: 14px;
    color: #777;
    font-weight: 500;
  }

  div {
    height: 20px;
    animation: 1s spin linear infinite;

    @keyframes spin {
      to {
        transform: rotate(-360deg);
      }
    }
  }
`;
